import { Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-formReports',
  templateUrl: './formReports.component.html',
  styleUrls: ['./formReports.component.scss'],
})

export class FormReportsComponent implements OnInit {
  @Output() messageToEmit = new EventEmitter<boolean>();
  @Input() folderID: number = 0;
  @Input() transactionID: number = 0;
  // @Output() showShareFile = new EventEmitter<boolean>();
  // @Output() showShareFaxFile = new EventEmitter<boolean>();
  // @Output() openDocumentDetail = new EventEmitter<boolean>();
  // @Output() openBindFieldDetail = new EventEmitter<boolean>();  
  // @Output() documentViewer = new EventEmitter<boolean>();
  @Output() htmlData = new EventEmitter<boolean>();
  // showShareFaxFile: boolean = false;

  
  currentUser: any;
  selected = 'All';  
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  
  list: boolean = false;
  grid: boolean = true;  
  
  indexExpanded: number;
  // clickEventsubscription: any;
  // clickEventsubscriptionFax: any;
  // clickEventsubscriptionRemoveFax: any;
  // clickEventsubscriptionPreviousNextCore: any;
  // clickEventsubscriptionRemoveRequest: any;
 
  
  dialogRef: MatDialogRef<any, any>;
  OfficeIDList: any = [];
  myOfficeID: any;
  SelectedModuleName: any = [] = [];
  mainModuleName:any;  

  @Input() modulename: string;
  @Input() mainModulename: string;
  @Input() FormFolderReportList:any=[]=[];
  
  menuModulesList:any=[]=[];
  step = 0;
  ViewDocument: boolean = true;

  constructor(private http: HttpClient, private httpBackend: HttpBackend,     
    private encryptionAlgo: EncryptionService,private reusableClass: ReusableClasses,
    private toastr: ToastrService,private router: Router, 
    private _dataSharingService: DataSharingService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');    
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }
 

  ngOnDestroy() {
    // this.clickEventsubscriptionPreviousNextCore.unsubscribe();
    // this.clickEventsubscription.unsubscribe();
    // this.clickEventsubscriptionFax.unsubscribe();
    // this.clickEventsubscriptionRemoveRequest.unsubscribe();
    // this.clickEventsubscriptionRemoveFax.unsubscribe();
  }

  ngOnInit(): void {    
    //this.mainModuleName = ModuleName.Core;
    //sessionStorage.setItem('edashboard', "false");  
  
    //this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    //var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));      
       

    //this.SelectedModuleName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);

    // this.clickEventsubscriptionPreviousNextCore = this._dataSharingService.getNextPreviousDocumentFromCore().subscribe((result) => {
    //   if (result) {
    //     //this.getAllFolders();       
    //   }
    // });

    // this.clickEventsubscription = this._dataSharingService.getClosePanelFromDocDetailsCore().subscribe((result) => {
    //   if (result) {
    //    // this.getAllFolders();       
    //   }
    // });

    // this.clickEventsubscriptionFax = this._dataSharingService.getClosePanelFaxForFileManager().subscribe((result) => {
    //   if (result) {
    //    // this.getAllFolders();       
    //   }
    // });

      
    //this.getAllFolders();   

    //sessionStorage.setItem('HeaderModuleName', this.SelectedModuleName[0].orgModuleName);
    //this._dataSharingService.sendSelectedModuleName(this.SelectedModuleName[0].orgModuleName);
    //this._dataSharingService.sendShowFormsSiderbar(this.SelectedModuleName[0].orgModuleName);
  }
 
  showList() {
    this.list = !this.list;
    this.grid = false;
  }

  showGrid() {
    this.grid = !this.grid;
    this.list = false;
  }  
 

  togglePanels(index: number) {
    sessionStorage.setItem('currentCoreTabIndex', `${index}`);
    this.indexExpanded = index;
    //== this.indexExpanded ? 0 : index;
  }

  openHtmlData(message: boolean, document) {
    var ReqModel = {
      // formID :document.formID,
      transactionID: this.transactionID,
      placeholderID: 0,
      formID :document.formID
    }
    this._dataSharingService.sendSelectedHTMLDataForContact(ReqModel);
    this.htmlData.emit(message);
  }

 
}




